import { configureStore } from '@reduxjs/toolkit';
import bookingSystemReducer from './bookingSystemSlice';

export const store = configureStore({
  reducer: {
    bookingSystem: bookingSystemReducer
  },
})